import { NavItem } from '@/interfaces';
import { Component, Mixins } from 'vue-property-decorator';
import PrivilegeMixin from './PrivilegeMixin';
// tslint:disable: quotemark

@Component
export default class NavBarMixin extends Mixins(PrivilegeMixin) {
  public get navItems() {
    const navItems: NavItem[] = [];
    const manageItems = {
      name: 'Beheer',
      url: '/manage',
      menuItems: [
        { name: 'Artikelen', url: '/products' },
        { name: 'Gebruikers', url: '/users' },
        { name: 'Eenheden', url: '/unittypes' }
      ]
    };
    if (this.isSuperUser()) {
      manageItems.menuItems.push({ name: 'Templates', url: '/templates' });
      manageItems.menuItems.push({ name: 'ErrorEvents', url: '/errorevents' });
      manageItems.menuItems.push({ name: 'ApiEvents', url: '/apievents' });
    }
    navItems.push(manageItems);
    navItems.push({
      name: 'Projecten',
      url: '/projects'
    });
    navItems.push({
      name: 'Verkoop',
      url: '/sale',
      menuItems: [
        { name: 'Klanten', url: '/customers' },
        { name: 'Facturen', url: '/invoices' },
        { name: 'Offertes', url: '/quotes' },
        { name: 'Werkbonnen', url: '/orders' },
        { name: "Kredietnota's", url: '/credit_notes' },
        { name: 'Templates', url: '/templates' }
      ]
    });
    return navItems;
  }
}
